import React from 'react';

import { useDayJsCountdown } from '@pkg/hooks';

import { Time } from '../styles';

export type TimeLeftProps = {
    expiration: string;
    onExpired?: () => void;
    compact?: boolean;
};
export const TimeLeft = ({ expiration, onExpired, compact }: TimeLeftProps) => {
    const { days, hours, minutes, seconds } = useDayJsCountdown(expiration, onExpired);
    if (compact) return <Time $compact>{`${days > 0 ? `${days}D ` : ''}${hours}H ${minutes}M ${seconds}S`}</Time>;
    return (
        <Time>
            {days}
            <span>D</span>
            {hours} <span>H</span>
            {minutes}
            <span>M</span>
            {seconds}
            <span>S</span>
        </Time>
    );
};
